<oe-flat-widget [title]="'GENERAL.CUR_MONTH_PRODUCTION' | translate" [icon]="{name: 'oe-production', color: 'production'}">
  <ng-container>
    <p class="signage-font-edge5card">{{getCurMonthProduction()}}</p>
  </ng-container>
</oe-flat-widget>
